<script lang="ts" context="module">
  import { writable } from "svelte/store";
  import { eventStore } from "../forms/stores";

  export interface Step {
    number: number;
    name: string;
    hidden: boolean;
  }

  export class StepperControl {
    step = 1;
    steps: Step[] = [];
    changes = writable();
    scrollToElementChanges = eventStore();

    prevEnabled() {
      return !!this.steps.find((_) => _.number === this.step - 1);
    }
    nextEnabled() {
      return !!this.steps.find((_) => _.number === this.step + 1);
    }

    prev() {
      if (this.prevEnabled()) {
        this.step--;
      }
      this.update();
      this.scrollToElement();
    }
    next() {
      if (this.nextEnabled()) {
        this.step++;
      }
      this.update();
      this.scrollToElement();
    }

    registerStep(step: Partial<Step>) {
      step.number = this.steps.length + 1;
      this.steps.push(step as Step);
      return step;
    }

    scrollToElement() {
      this.scrollToElementChanges.set({});
    }

    update() {
      this.changes.set({});
    }
  }
</script>

<script lang="ts">
  import { onMount, setContext, tick } from "svelte";
  import { scrollToCenter, scrollToTop } from "../forms/utils";

  export let stepper: StepperControl = null;
  export let showActions: boolean = false;

  stepper = stepper || new StepperControl();
  stepper.changes.subscribe(() => (stepper = stepper));

  let element: HTMLDivElement;
  stepper.scrollToElementChanges.subscribe(async () => {
    await tick();
    if (element) scrollToTop(element, 200);
  });

  setContext("stepper", stepper);

  onMount(() => stepper.update());
</script>

<div bind:this={element} class="stepper">
  <slot {stepper} />

  {#if showActions}
    <div class="stepper-actions">
      <button class="bs3-btn bs3-btn-sm bs3-btn-secondary" on:click={(_) => stepper.prev()} disabled={!stepper?.prevEnabled()}>prev</button>
      <button class="bs3-btn bs3-btn-sm bs3-btn-secondary" on:click={(_) => stepper.next()} disabled={!stepper?.nextEnabled()}>next</button>
    </div>
  {/if}
</div>

<style lang="scss" global>
  .stepper {
    display: flex;
    flex-flow: column;
    scroll-margin-top: 100px;
  }
  .stepper-actions {
    margin-top: 1em;
    border-top: solid 1px rgba(#000, 0.1);
    padding-top: 1em;
  }
</style>
